export default __webpack_public_path__ + "static/media/Forca-guld-transparent-small-cut.ca2c3adf.png";